/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   buildStaticImageUrl
 */

import { imageStaticUrl } from '../../../settings/settings'

import { buildImageUrl } from './buildImageUrl'

export const buildStaticImageUrl = (args) => {
  const { url, fallbackUrl } = args

  if (!url && !fallbackUrl) {
    return ''
  }

  return buildImageUrl({ ...args, url: imageStaticUrl(args.url) })
}
